import { Inline } from "PFComponents/containers";
import { Icon } from "PFComponents/icon";
import { Typography } from "PFComponents/typography";
import { useTranslation } from "react-i18next";

import css from "./skills_frameworks_empty_state.module.scss";

export const SkillsFrameworksEmptyState = () => {
  const { t } = useTranslation("activities", { keyPrefix: "form.sections.skillsFrameworks" });

  return (
    <Inline alignItems="center">
      <Icon name="missing" color="paletteBlue2" />
      <Typography variant="labelRegular" className={css.emptyStateText}>
        {t("noSkillsFrameworksAdded")}
      </Typography>
    </Inline>
  );
};
